export interface IAccount {
	[key: string]: any;
	Name?: string;
	Fax?: string;
	Type?: string;
	Phone?: string;
	Jigsaw?: string;
	OwnerId?: string;
	SicDesc?: string;
	Website?: string;
	Industry?: string;
	ParentId?: string;
	BillingCity?: string;
	Description?: string;
	BillingState?: string;
	ShippingStreet?: string;
	ShippingCity?: string;
	AccountNumber?: string;
	AccountSource?: string;
	AnnualRevenue?: number;
	BillingStreet?: string;
	ShippingState?: string;
	BillingCountry?: string;
	ShippingCountry?: string;
	BillingPostalCode?: string;
	NumberOfEmployees?: string;
	ShippingPostalCode?: string;
}
